import * as yup from 'yup';
import axios from 'axios';
import { withFormik } from 'formik';
import { withRouter } from 'react-router-dom';

import RegisterForm from './RegisterForm';

const mapPropsToValues = () => ({
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
});

const validationSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup
    .string()
    .email()
    .required(),
  password: yup.string().required(),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required(),
});

const handleSubmit = async (props, bag) => {
  bag.setSubmitting(true);
  // TODO send only selected props (without confirmation???)
  try {
    const { data } = await axios.post('/api/v1/auth/register', props);

    if (data.success) {
      bag.props.onSuccess();
    } else {
      bag.setErrors({ summary: data.errorMessage });
    }
  } catch (e) {
    bag.setErrors({ summary: e.response.data.errorMessage });
  }

  bag.setSubmitting(false);
};

export default withRouter(
  // TODO use redux compose here
  withFormik({
    mapPropsToValues,
    validationSchema,
    handleSubmit,
  })(RegisterForm),
);
